exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.canopy-list-renderer {\n  border-bottom: 1px solid #e0e0e0; }\nperfect-scrollbar {\n  height: 50vh;\n  min-height: 350px; }\n.asset-indicators {\n  padding-right: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/allocation-editor/allocation-editor.component.scss
// module id = ../../../../../src/app/shared/components/allocation-editor/allocation-editor.component.scss
// module chunks = main